// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 926) return "/vendors/swiper.min.js";
	// return url for filenames based on template
	return undefined;
};